import script from "./SocialloginIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./SocialloginIndex.vue?vue&type=script&setup=true&lang=js"

import "./SocialloginIndex.vue?vue&type=style&index=0&id=34ecb8a8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34ecb8a8"]])

export default __exports__